export default __webpack_public_path__ + "static/media/B_Sharon.1572cd82.jpg";